<template>
    <div id="app" class="o-app">
        <o-header :profileUser="currentUser" :is-admin="isAdmin" :is-client-admin="isClientAdmin"></o-header>
        <div class="wrapper">
          <page>
              <router-view @showModal="onShowModal" :is-admin="isAdmin" :is-client-admin="isClientAdmin" />
              <o-footer></o-footer>
          </page>
        </div>

        <portal-target name="globalModal">
          <!-- the content of <portal> (modals) will appear here, fully functional -->
        </portal-target>

    </div>
</template>

<script>
import Header from '@/components/Header/header'
import Footer from '@/components/Footer/footer'
// import Sidebar from '@/components/Sidebar/sidebar'
import Page from '@/components/Page/page'
import {profileMixin} from '@/mixins/profileMixin'

import ls from 'local-storage'

export default {
  name: 'App',
  mixins: [profileMixin],
  components: {
    'o-header': Header,
    'o-footer': Footer,
    Page
  },
  data: () => ({
    modalConfig: null,
    modalId: null,
    showModal: {
      edit: false,
      delete: false,
      adjustments: false,
      confirm: false,
      invoiceNumber: false
    }
  }),
  computed: {
    isAdmin () {
      return this.user && this.user.role === 1
    },
    isClientAdmin () {
      return this.user && this.user.role === 4
    },
    currentUser () {
      return this.user && this.user.name
    }
  },
  methods: {
    onShowModal (type, option, id) {
      this.modalConfig = option
      this.modalId = id
      this.showModal[type] = true
    }
  },
  created () {
    const user = ls.get('ot-user')
    this.$store.commit('profile/setCurrentUser', user)
  }
}
</script>

<style lang="scss">
    @import "scss/o-app";
</style>



// WEBPACK FOOTER //
// src/App.vue